import type { ReactNode } from 'react';
import { cn } from './cn';

/** The surface every block of content sits on. */
export const cardClass = 'rounded-card border border-line bg-surface p-6 shadow-card';

/**
 * A titled block. `flush` drops the inner padding below the title, for a table that runs edge to edge.
 */
export function Card({
  title,
  description,
  actions,
  flush = false,
  className,
  children,
}: {
  title?: string;
  description?: ReactNode;
  actions?: ReactNode;
  flush?: boolean;
  className?: string;
  children: ReactNode;
}) {
  const hasHeader = Boolean(title || actions);
  return (
    <section
      className={cn('rounded-card border border-line bg-surface shadow-card', !flush && 'p-5', className)}
      aria-label={title}
    >
      {hasHeader ? (
        <div className={cn('flex flex-wrap items-start justify-between gap-3', flush ? 'px-5 pt-5' : 'mb-4')}>
          <div className="grid gap-0.5">
            {title ? <h2 className="text-base font-semibold">{title}</h2> : null}
            {description ? <p className="text-label text-muted">{description}</p> : null}
          </div>
          {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
